export default (context, payload) => {
    const moduleId = context.getters.moduleId;
    const apiData = context.rootState.appState.data;
    const setAttribute = payload.oneLni.storeUtils.setAttribute;

    // Set labels manually
    setAttribute(context, `${moduleId}_name`, 'labelText', apiData['employer.name.label']);
    setAttribute(context, `${moduleId}_phone-number_phone`, 'labelText', apiData['employer.phone.label']);
    setAttribute(context, `${moduleId}_email-address_input-text`, 'labelText', apiData['employer.email.label']);
    setAttribute(context, `${moduleId}_address`, 'labelText', apiData['employer.address.label']);
    setAttribute(context, `${moduleId}_address`, 'countyOptions', apiData.counties);

    context.commit(`${payload.sourceId}/ADD_TRACKED_ERRORS`, [
        `${moduleId}_name`,
        `${moduleId}_phone-number`,
    ], {
        root: true,
    });

};